var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('v-progress-circular',{attrs:{"size":30,"color":"primary","indeterminate":""}}):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }